import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-adds-banner-sidebar',
  templateUrl: './product-adds-banner-sidebar.component.html',
  styleUrls: ['./product-adds-banner-sidebar.component.css']
})
export class ProductAddsBannerSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
